import React from 'react';

import type { MentionProvider } from '@atlaskit/mention/types';

/**
 * Context shape for an injectable mention provider used across the
 * Rovo chat surfaces. Widened from `SmartMentionResource` to the
 * broader `MentionProvider` interface in TREX-1572 so host
 * integrations can hand in any compliant provider (including
 * `RovoChatMentionResource`, which extends `AbstractMentionResource`
 * directly rather than `SmartMentionResource`).
 *
 * This is a non-breaking widening — every existing
 * `SmartMentionResource` instance still satisfies `MentionProvider`.
 */
// oxlint-disable-next-line eslint/no-redeclare
type RovoMentionProvider = { value?: MentionProvider };
const initialState: RovoMentionProvider = {};

export const rovoMentionProviderDefaults: RovoMentionProvider = initialState;

const rovoMentionProvider = React.createContext<RovoMentionProvider>(initialState);
export const RovoMentionProvider: React.Provider<RovoMentionProvider> =
	rovoMentionProvider.Provider;
export const useRovoMentionProvider = (): RovoMentionProvider =>
	React.useContext(rovoMentionProvider);
